var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Product/UI_Functional_Icons/edit_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.6158762,2.38425 C15.0458762,1.8135 14.2868762,1.5 13.4806262,1.5 C12.6751262,1.5 11.9161262,1.8135 11.3461262,2.38425 L2.78937624,10.94025 C2.78937624,10.94025 2.78862624,10.9425 2.78712624,10.94325 C2.72637624,11.00475 2.62287624,11.16675 2.59137624,11.289 L1.52262624,15.567 C1.45812624,15.822 1.53387624,16.0935 1.71987624,16.27875 L1.72062624,16.2795 L1.72137624,16.28025 C1.90737624,16.46625 2.17737624,16.542 2.43312624,16.47825 L6.71112624,15.408 C6.83337624,15.3765 6.99612624,15.273 7.05687624,15.21225 C7.05762624,15.2115 7.05987624,15.21 7.05987624,15.21 L15.6166262,6.65475 C16.1866262,6.084 16.5008762,5.3265 16.5001262,4.5195 C16.5001262,3.71325 16.1866262,2.955 15.6166262,2.38425 L15.6158762,2.38425 Z M10.8083762,5.046 L12.9556262,7.19325 L6.52962624,13.61925 L4.38237624,11.472 L10.8083762,5.046 Z M3.28137624,14.7195 L3.72762624,12.939 L5.06262624,14.27475 L3.28137624,14.7195 Z M14.5568762,3.4455 C15.1298762,4.01925 15.1298762,5.01975 14.5568762,5.5935 L14.0176262,6.1335 L11.8681262,3.98475 L12.4088762,3.4455 C12.9826262,2.8725 13.9831262,2.87175 14.5568762,3.4455 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Participaints-Modal",
    transform: "translate(-274.000000, -129.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(0.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Participaint"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Participaint-Info",
    transform: "translate(16.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-Mic-Icons",
    transform: "translate(257.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Edit",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mixin/Fill/Black---Disabled",
    mask: "url(#mask-2)",
    fill: "white",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mixin/Fill/Black"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.6394e8ea26d98cb02e7469b6239aa374.svg";
export { ForwardRef as ReactComponent };